<template>
  <div class="page-navigation">
    <paginate
      :page-count="totalPage"
      :page-range="displayPageRange"
      :prev-text="''"
      :next-text="''"
      :container-class="frontEndFrameworkPaginationClassName"
      :page-class="pageClassName"
      :page-link-class="pageLinkClassName"
      :prev-link-class="prevLinkClassName"
      :next-link-class="nextLinkClassName"
      :click-handler="pageChange"
      v-model="displayPage"
    ></paginate>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';

export default {
  props: {
    totalPage: {
      required: true,
      type: Number,
    },
    displayPageRange: {
      type: Number,
      default: () => 10,
    },
    frontEndFrameworkPaginationClassName: {
      required: true,
      type: String,
    },
    currentSelectedPage: {
      required: true,
      type: Number,
      default: () => 1,
    },
    pageClassName: {
      type: String,
      default: () => 'page-item',
    },
    pageLinkClassName: {
      type: String,
      default: () => 'page-link',
    },
    prevLinkClassName: {
      type: String,
      default: () => 'prev-link',
    },
    nextLinkClassName: {
      type: String,
      default: () => 'next-link',
    },
  },
  data() {
    return {
      displayPage: 0,
    };
  },
  mounted() {
    this.displayPage = this.currentSelectedPage;
  },
  components: {
    Paginate,
  },
  methods: {
    pageChange(page) {
      this.$emit('pageChange', page);
    },
  },
  watch: {
    currentSelectedPage: {
      handler(value) {
        this.displayPage = value;
      },
    },
  },
};
</script>

<style scoped>
.page-navigation {
  display: flex;
  justify-content: center;
}

.page-navigation >>> .page-link {
  margin-right: 8px;
  padding: 14px 0;
  border-radius: 4px;
  border: none;
  color: #9a9a9a;
  text-align: center;
  min-width: 32px;
  height: 50px;
  font-size: 16px;
}

.page-navigation >>> .active > a {
  background: #252525;
  color: #ffffff;
}

.page-navigation >>> .prev-link {
  margin-right: 8px;
  background-image: url('data:image/svg+xml;utf-8,<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0031 19.2999L0.703125 9.99995L10.0031 0.699951L10.9031 1.59995L2.47813 9.99995L10.9031 18.4L10.0031 19.2999Z" fill="%239A9A9A"/></svg>');
}

.page-navigation >>> .next-link {
  background-image: url('data:image/svg+xml;utf-8,<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.996874 19.2999L10.2969 9.99995L0.996874 0.699951L0.096874 1.59995L8.52187 9.99995L0.096874 18.4L0.996874 19.2999Z" fill="%239A9A9A"/></svg>');
}

.page-navigation >>> .prev-link,
.page-navigation >>> .next-link {
  border-radius: 4px;
  border: 1px solid #9a9a9a;
  width: 32px;
  height: 50px;
  background-repeat: no-repeat;
  background-position: center;
}

.page-navigation >>> .pagination {
  margin: 48px 0;
}
</style>
